type DescriptionType = {
  [key in 'en' | 'pl']: string
}

type ErrorCodeType = {
  [key: number]: {
    descriptions: DescriptionType
  }
}

type ErrorCodesType = {
  [key: number]: ErrorCodeType
}

export const ERROR_CODES: ErrorCodesType = {
  302: {
    2000: {
      descriptions: {
        en: 'You need contact office to get mobile app agreement',
        pl: 'Skontaktuj się z biurem, aby uzyskać umowę na panel aplikacji mobilnej'
      }
    },
    2001: {
      descriptions: {
        en: 'Your agreement is not signed yet',
        pl: 'Twoja umowa nie jest jeszcze podpisana'
      }
    },
    2002: {
      descriptions: {
        en: 'Your agreement is terminated',
        pl: 'Twoja umowa została rozwiązana'
      }
    },
    2003: {
      descriptions: {
        en: 'Unknown error',
        pl: 'Nieznany błąd'
      }
    }
  },
  400: {
    1011: {
      descriptions: {
        en: 'Invalid code. Make sure the code exists.',
        pl: 'Nieprawidłowy kod. Upewnij się, że kod istnieje.'
      }
    },
    1012: {
      descriptions: {
        en: 'This code is either expired or not yet active.',
        pl: 'Kod wygasł lub nie jest jeszcze aktywny.'
      }
    },
    1013: {
      descriptions: {
        en: 'This folder is already assigned to the order',
        pl: 'Ten folder jest już przypisany do zamówienia'
      }
    },
    1014: {
      descriptions: {
        en: 'Stripe Error',
        pl: 'Błąd Stripe'
      }
    },
    1015: {
      descriptions: {
        en: 'User already have stripe account',
        pl: 'Użytkownik posiada już konto stripe'
      }
    },
    1016: {
      descriptions: {
        en: 'First you need to create a ddpanel-sub-account for the user',
        pl: 'Najpierw utwórz subkonto do ddpanelu dla tego użytkownika'
      }
    },
    1017: {
      descriptions: {
        en: 'First you need to create a Stripe account for the user',
        pl: 'Najpierw utwórz konto Stripe dla tego użytkownika'
      }
    },
    1018: {
      descriptions: {
        en: 'You provided wrong old password',
        pl: 'Podano złe stare hasło do konta'
      }
    },
    1022: {
      descriptions: {
        en: 'These diet is already used in the application.',
        pl: 'Ta dieta jest już obecnie używana w aplikacji.'
      }
    }
  },
  403: {
    1001: {
      descriptions: {
        en: 'Invalid request, didn\'t include platform or app-version',
        pl: 'Nieprawidłowe żądanie, brak platformy lub wersji aplikacji'
      }
    },
    1002: {
      descriptions: {
        en: 'Wrong app version',
        pl: 'Nieprawidłowa wersja aplikacji'
      }
    },
    1003: {
      descriptions: {
        en: 'Invalid platform',
        pl: 'Nieprawidłowa platforma'
      }
    },
    1004: {
      descriptions: {
        en: 'App version is outdated',
        pl: 'Wersja aplikacji jest przestarzała'
      }
    },
    1005: {
      descriptions: {
        en: 'Your account is pending deletion.',
        pl: 'Twoje konto zostało zgłoszone do usunięcia.'
      }
    },
    1006: {
      descriptions: {
        en: 'Unavailable for users authenticated as service.',
        pl: 'Niedostępne dla użytkowników zautoryzowanych jako serwis.'
      }
    },
    1007: {
      descriptions: {
        en: 'Resource created by dietitian, cannot be changed.',
        pl: 'Utworzone przez dietetyka, brak możliwości edycji'
      }
    },
    1009: {
      descriptions: {
        en: 'This code is attached to other user',
        pl: 'Ten kod został już zużyty przez kogoś innego'
      }
    }
  },
  503: {
    1008: {
      descriptions: {
        en: 'Application currently is in maintenance mode. Try again later.',
        pl: 'Trwa przerwa serwisowa w działaniu aplikacji, Spróbuj później'
      }
    }
  }
}
